import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

export const CheckBox = React.forwardRef(({ className = '', checked, ...props }, ref) => {
  return (
    <div className="relative">
      <input
        type="checkbox"
        ref={ref}
        checked={checked}
        className={`
          peer h-4 w-4 shrink-0 rounded-sm border border-slate-200 ring-offset-white 
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 
          focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 
          data-[state=checked]:bg-slate-900 data-[state=checked]:text-slate-50
          ${className}
        `}
        {...props}
      />
      {checked && (
        <CheckIcon className="absolute top-0 left-0 h-4 w-4 text-white pointer-events-none" />
      )}
    </div>
  );
});

CheckBox.displayName = 'CheckBox';
